import cx from 'classnames';
import NextImage from 'next/image';

// Static 1x1 placeholder used for the blur-up effect. Previously this was
// generated on the fly by the /api/v1/images endpoint (plaiceholder + sharp),
// which has been removed to keep the serverless bundle small.
const BLUR_DATA_URL =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

export default function Image({ className, src, ...props }) {
  let objectFit = 'none';
  if (className?.includes('object-cover')) objectFit = 'cover';
  if (className?.includes('object-contain')) objectFit = 'contain';
  if (className?.includes('object-fill')) objectFit = 'fill';

  return (
    <div className={cx('relative', className)}>
      <NextImage
        unoptimized
        blurDataURL={BLUR_DATA_URL}
        layout="fill"
        objectFit={objectFit}
        placeholder="blur"
        src={src}
        {...props}
      />
    </div>
  );
}
